import React, { memo } from 'react'

import routes from '~/routes'
import useScreenMobile from '~/utils/hooks/useScreenMobile'

import DesktopSidebar from './Desktop'
import useCustom from './hooks'
import Menu from './Menu'
import MobileSidebar from './Mobile'

const Sidebar = () => {
  const { data, methods } = useCustom()
  const isMobile = useScreenMobile()

  return isMobile ? (
    <MobileSidebar
      open={data.toggleMobileDrawer.value}
      handleClickToggle={data.toggleMobileDrawer.toggle}
    >
      <Menu
        routes={routes}
        currentPath={data.currentPath}
        firstPath={data.firstPath}
        isPermissionGranted={methods.isPermissionGranted}
        open={data.toggleMobileDrawer.value}
        pushHistory={methods.pushHistory}
      />
    </MobileSidebar>
  ) : (
    <DesktopSidebar open={data.open} handleDrawer={methods.handleDrawer}>
      <Menu
        routes={routes}
        currentPath={data.currentPath}
        firstPath={data.firstPath}
        isPermissionGranted={methods.isPermissionGranted}
        open={data.open}
        pushHistory={methods.pushHistory}
      />
    </DesktopSidebar>
  )
}

export default memo(Sidebar)
